module.exports = "/dist/media/icons.b06871f2.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-css/themes/default/assets/fonts/icons.ttf
// module id = 889
// module chunks = 0